import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/mortgage/rate/list',
      data
    });
  },

  update(data) {
    return http.post({
      url: '/la/admin/mortgage/rate/update',
      data,
      dataType: 'form'
    });
  },
  remove(data) {
    return http.post({
      url: '/la/admin/mortgage/rate/delete',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  createCycle(data) {
    return http.post({
      url: '/la/admin/mortgage/rate/add',
      data,
      dataType: 'form'
    });
  }
};
